import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtService, LocalStorageService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class BlockGuard {
  public blockAuth: boolean = false;
  constructor(
    private router: Router,
    private jwtService: JwtService,
    private storage: LocalStorageService,
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.storage.getItem('token')) {
      this.router.navigate(['/']);
      return false
    } else {
      return true;
    }
  }
}
